<template>
  <div>
    <header class="light outline">
      <h5 class="comfortaa">Websites</h5>
      <p>Connected sites</p>
    </header>
    <div class="w3-row w3-padding w3-border-bottom sectionHeader w3-light-grey">
      <div class="w3-col s6">Website</div>
      <!-- <div class="w3-col s6"><span class="w3-right">Visitors <span style="font-size:0.7em; font-style:italic;">(30 Days)</span></span></div> -->
    </div>
    <template v-if="sitesLoaded">
      <template v-if="state.user.sites && state.user.sites.total > 0">
        <template v-if="limit > 0">
          <div class="w3-row w3-padding w3-hover-light-grey" v-for="(site, index) in state.user.sites.list.slice(0, limit)" :key="index" @click="editSite(site)">
            <div class="w3-col s12">{{site}}</div>
            <!-- <div class="w3-col s6"><span class="w3-right roboto" style="font-size:0.8rem;">0</span></div> -->
          </div>
          <template v-if="state.user.sites.list.length > limit">
            <router-link tag="div" to="/sites" class="w3-row w3-padding w3-light-grey w3-text-green pointer outline">View {{state.user.sites.list.length - limit}} More</router-link>
          </template>
        </template>
        <template v-else>
          <div class="w3-row w3-padding w3-hover-light-grey" v-for="(site, index) in state.user.sites.list" :key="index" @click="editSite(site)">
            <div class="w3-col s6">{{site}}</div>
            <!-- <div class="w3-col s6"><span class="w3-right roboto" style="font-size:0.8rem;">0</span></div> -->
          </div>
        </template>
      </template>
      <template v-else>
        <div class="w3-row w3-padding w3-hover-light-grey">
          <div class="w3-col s12">No connected sites. <router-link tag="a" to="support">Contact us</router-link> to discuss your next web project.</div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
const dataStore = require('../dataStore').default

export default {
  name: 'invoicesList',
  props: {
    limit: 0
  },
  data () {
    return {
      state: dataStore.state,
      sitesLoaded: false
    }
  },
  created() {
    dataStore.getClientSites().then((res) => {
      if (res !== 'success') {
        // no success
      } else {
        this.sitesLoaded = true
      }
    })
  },
  methods: {
    editSite(site) {
      dataStore.getSiteData(site).then((res) => {
        this.state.activeSite = {
          domain: site
        }
        let data = res
        this.state.siteData = this.mergeRecursive(this.state.siteData, data)
        this.state.siteData.content.news.items = this.state.siteData.content.news.items.sort((a, b) => (new Date(b.created) > new Date(a.created)) ? 1 : -1)
        this.state.cmsView = true
        this.$router.push('/cms')
        dataStore.getProductReviews(this.state.activeSite.domain)
        // dataStore.getSiteUsers(this.state.activeSite.domain)
      })
    },
    mergeRecursive(obj1, obj2) {
      for (var p in obj2) {
        try {
          if (obj2[p].constructor === Object) {
            obj1[p] = this.mergeRecursive(obj1[p], obj2[p])
          } else {
            obj1[p] = obj2[p]
          }
        } catch (e) {
          obj1[p] = obj2[p]
        }
      }
      return obj1
    }
  }
}
</script>

<style>
.w3-responsive {font-size:9pt; font-weight:500;}
td.tableItems {max-width:300px;}
</style>



// WEBPACK FOOTER //
// src/components/sitesList.vue